/* ==========================================================
   GREEN HOUSE · Landing Ritual Día y Noche
   Paquetes: 1 frasco (elige) · Ritual 2 (1+1) · 3x2 (combina 3)
   ========================================================== */
(function () {
  'use strict';

  function boot(root) {
    if (!root || root.dataset.ghReady === '1') return;
    root.dataset.ghReady = '1';

    var data = {};
    try {
      data = JSON.parse(root.querySelector('[data-gh-data]').textContent);
    } catch (e) {
      return;
    }

    /* ---------------- Contador perenne ---------------- */
    (function countdown() {
      var box = root.querySelector('[data-gh-clock]');
      if (!box) return;
      var span = parseFloat(root.dataset.ghHours || '24') * 3600 * 1000;
      var key = 'gh_promo_deadline_v1';
      var end = parseInt(localStorage.getItem(key) || '0', 10);
      if (!end || isNaN(end) || end <= Date.now()) {
        end = Date.now() + span;
        try { localStorage.setItem(key, String(end)); } catch (e) {}
      }
      var cells = box.querySelectorAll('[data-unit]');
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          end = Date.now() + span;
          try { localStorage.setItem(key, String(end)); } catch (e) {}
          left = span;
        }
        var s = Math.floor(left / 1000);
        var v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        cells.forEach(function (c) { c.textContent = pad(v[c.dataset.unit]); });
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ---------------- Galería ---------------- */
    (function gallery() {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gh-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gh-thumb]'));
      if (!slides.length) return;
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        var act = thumbs[i];
        if (act && act.parentElement) act.parentElement.scrollTo({ left: act.offsetLeft - 60, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var p = root.querySelector('[data-gh-prev]');
      var n = root.querySelector('[data-gh-next]');
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (n) n.addEventListener('click', function () { go(i + 1); });
      var main = root.querySelector('[data-gh-gal]');
      if (main) {
        var x0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 44) go(dx < 0 ? i + 1 : i - 1);
          x0 = null;
        }, { passive: true });
      }
      go(0);
    })();

    /* ---------------- FAQ ---------------- */
    root.querySelectorAll('[data-gh-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.gh-faq__item');
        var open = item.classList.contains('is-open');
        root.querySelectorAll('.gh-faq__item').forEach(function (it) { it.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    /* ---------------- Estado del selector ---------------- */
    var pick = '2';
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-gh-tier]'));
    var preset = tiers.filter(function (t) { return t.classList.contains('is-on'); })[0];
    if (preset) pick = preset.dataset.ghTier;

    /* tier 1: cuál frasco. tier 3: cuántos de cada uno (suman 3) */
    var single = 'day';
    var mix = { day: 2, night: 1 };
    var TOTAL3 = 3;

    function setText(sel, value) {
      if (value == null) return;
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }

    function offer() { return (data.tiers || {})[pick] || {}; }

    function renderSteps() {
      root.querySelectorAll('[data-gh-step]').forEach(function (el) {
        var k = el.dataset.ghStep;
        var q = el.querySelector('[data-gh-q]');
        if (q) q.textContent = mix[k];
        var minus = el.querySelector('[data-gh-minus]');
        var plus = el.querySelector('[data-gh-plus]');
        if (minus) minus.disabled = mix[k] <= 0;
        if (plus) plus.disabled = mix.day + mix.night >= TOTAL3;
      });
      var c = root.querySelector('[data-gh-steps-count]');
      if (c) {
        var t = mix.day + mix.night;
        c.textContent = t + ' de ' + TOTAL3 + ' frascos elegidos';
        c.style.color = t === TOTAL3 ? '#0a7434' : '#a06a00';
      }
    }

    function render() {
      var o = offer();
      setText('[data-gh-price-now]', '$' + o.price);
      setText('[data-gh-price-was]', o.was ? '$' + o.was : '');
      setText('[data-gh-price-unit]', o.unit);
      setText('[data-gh-cta-label]', o.cta);
      setText('[data-gh-cta-short]', o.short);
      setText('[data-gh-cta-sub]', o.sub);
      setText('[data-gh-headnote]', o.note);
      setText('[data-gh-sticky-sub]', o.stickySub);

      root.querySelectorAll('[data-gh-price-was]').forEach(function (el) {
        el.style.display = o.was ? '' : 'none';
      });
      root.querySelectorAll('[data-gh-price-tag]').forEach(function (el) {
        if (o.save) {
          el.textContent = 'Ahorras $' + o.save + (o.pct ? ' (' + o.pct + ')' : '');
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });

      tiers.forEach(function (t) {
        var on = t.dataset.ghTier === pick;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-checked', String(on));
      });

      root.querySelectorAll('[data-gh-choose]').forEach(function (el) {
        el.hidden = el.dataset.ghChoose !== pick;
      });

      root.querySelectorAll('[data-gh-single]').forEach(function (b) {
        b.classList.toggle('is-on', b.dataset.ghSingle === single);
        b.setAttribute('aria-checked', String(b.dataset.ghSingle === single));
      });

      renderSteps();

      var hint = root.querySelector('[data-gh-hint]');
      if (hint) {
        var txt = '';
        if (pick === '1') {
          txt = 'Llevas 1 frasco de ' + (single === 'day' ? data.day.name : data.night.name) + '.';
        } else if (pick === '2') {
          txt = 'Llevas 1 ' + data.day.name + ' + 1 ' + data.night.name + '.';
        } else {
          var parts = [];
          if (mix.day > 0) parts.push(mix.day + ' ' + data.day.name);
          if (mix.night > 0) parts.push(mix.night + ' ' + data.night.name);
          txt = parts.length
            ? 'Llevas ' + parts.join(' + ') + '. Uno va gratis.'
            : 'Elige tus 3 frascos para continuar.';
        }
        hint.textContent = txt;
        hint.style.color = '#0a7434';
      }
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        pick = t.dataset.ghTier;
        render();
      });
    });

    root.querySelectorAll('[data-gh-single]').forEach(function (b) {
      b.addEventListener('click', function () {
        single = b.dataset.ghSingle;
        render();
      });
    });

    root.querySelectorAll('[data-gh-step]').forEach(function (el) {
      var k = el.dataset.ghStep;
      var minus = el.querySelector('[data-gh-minus]');
      var plus = el.querySelector('[data-gh-plus]');
      if (minus) minus.addEventListener('click', function () {
        if (mix[k] > 0) { mix[k]--; render(); }
      });
      if (plus) plus.addEventListener('click', function () {
        if (mix.day + mix.night < TOTAL3) { mix[k]++; render(); }
      });
    });

    /* ---------------- Agregar al carrito ---------------- */
    var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-gh-cta]'));

    function buildItems() {
      var items = [];
      if (pick === '1') {
        items.push({ id: Number(data[single].variant_id), quantity: 1 });
      } else if (pick === '2') {
        items.push({ id: Number(data.day.variant_id), quantity: 1 });
        items.push({ id: Number(data.night.variant_id), quantity: 1 });
      } else {
        if (mix.day > 0) items.push({ id: Number(data.day.variant_id), quantity: mix.day });
        if (mix.night > 0) items.push({ id: Number(data.night.variant_id), quantity: mix.night });
      }
      return items;
    }

    function addToCart(e) {
      e.preventDefault();
      if (pick === '3' && mix.day + mix.night !== TOTAL3) {
        var target = root.querySelector('[data-gh-picker]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var c = root.querySelector('[data-gh-steps-count]');
        if (c) c.animate([{ opacity: 1 }, { opacity: 0.2 }, { opacity: 1 }, { opacity: 0.2 }, { opacity: 1 }], { duration: 700 });
        return;
      }
      var btn = e.currentTarget;
      var restore = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Agregando...';

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: buildItems() })
          });
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || 'No se pudo agregar');
          var code = offer().code;
          window.location.href = code
            ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
            : '/checkout';
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.innerHTML = restore;
          alert('No pudimos agregar tu pedido: ' + err.message);
        });
    }

    ctas.forEach(function (c) { c.addEventListener('click', addToCart); });

    /* ---------------- Sticky móvil ---------------- */
    (function sticky() {
      var bar = root.querySelector('[data-gh-sticky]');
      var anchor = root.querySelector('[data-gh-picker]');
      var last = root.querySelector('.gh-final');
      if (!bar || !anchor) return;
      var lastRun = 0;
      function update() {
        lastRun = Date.now();
        var passed = anchor.getBoundingClientRect().bottom < 0;
        var atEnd = last ? last.getBoundingClientRect().top < window.innerHeight : false;
        bar.classList.toggle('is-on', passed && !atEnd);
      }
      function onScroll() {
        if (Date.now() - lastRun < 80) return;
        update();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    })();

    render();
  }

  function init() { document.querySelectorAll('[data-gh-root]').forEach(boot); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
